import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { LogowithTitle } from "../config";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleNavigate = (path) => {
  setIsOpen(false);   // close hamburger menu
  navigate(path);    // SPA navigation
};
  return (
    <nav className="bg-white border-b border-b-black bg-colors-eggshell shadow-sm fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:py-2">
        <div className="flex justify-between items-center h-12">
          <div className="flex-shrink-0" onClick={() => navigate("/")}>
            <div className="flex flex-row">
            <LogowithTitle
              className="sm:w-[15vw] w-[30vw] cursor-pointer"
            />
          <div className="flex flex-col items-center">
                <img
                  src="./Startup-India.webp"
                  alt="Startup India Logo"
                  className="w-[120px] h-auto object-contain"
                />
                <span className="text-xs italic pl-2 text-gray-600 text-center">
                  Recognized by DPIIT
                </span>
            </div>
            </div>
          </div>

          <div className="flex items-center">
            <div className="hidden md:ml-6 md:flex md:space-x-8">
              <a
                href="/about"
                className="text-gray-700 hover:text-[#77c36f] text-center px-3 py-2 text-sm font-medium"
              >
                About Us
              </a>
            </div>
            <div className="hidden md:flex items-center">
              <button
                onClick={() => navigate("/login")}
                className="text-gray-700 hover:text-[#77c36f] px-3 py-2 text-sm font-medium"
              >
                Login
              </button>
              <button
                className="ml-4 bg-primary-color text-white px-4 py-2 rounded-lg text-sm font-medium border border-black 
               hover:shadow-[6px_6px_0px_black] 
               hover:translate-y-[-5px] 
               transition-all duration-300 ease-in-out"
                onClick={() => navigate("/signup")}
              >
                Get Started
              </button>
            </div>
          </div>
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <a
              href="/about"
              className="block px-3 py-2 text-gray-700 text-center hover:text-[#77c36f] text-base font-medium"
            >
              About Us
            </a>
            <div className="mt-4 space-y-2">
              <button
                className="w-full text-center px-3 py-2 text-gray-700 hover:text-primary-color text-base font-medium"
                onClick={() => handleNavigate("/login")}
              >
                Login
              </button>
              <button
                className="w-full bg-primary-color text-white px-4 py-2 rounded-lg text-base font-medium  
               hover:shadow-[6px_6px_0px_black] 
               hover:translate-y-[-5px] 
               transition-all duration-300 ease-in-out"
                onClick={() => handleNavigate("/signup")}
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
